<template>
  <svg
    aria-hidden="true"
    width="90px"
    height="90px"
    viewBox="0 0 100.11 100.11"
    :class="$attrs.class"
  >
    <!-- Outer circle -->
    <path
      :fill="color"
      d="M50.05,99.97C22.41,99.97,0,77.56,0,49.92S22.41-.13,50.05-.13s50.05,22.41,50.05,50.05-22.41,50.05-50.05,50.05"
    />
    <!-- Play symbol -->
    <path
      fill="#fff"
      d="M43.55,40.14l16.97,9.79-16.97,9.75v-19.55ZM50.03,27.09s-20.39,0-25.51,1.33c-2.74.77-5,3.02-5.76,5.8-1.33,5.12-1.33,15.72-1.33,15.72,0,0,0,10.64,1.33,15.68.77,2.78,2.98,5,5.76,5.76,5.16,1.37,25.51,1.37,25.51,1.37,0,0,20.44,0,25.55-1.33,2.78-.77,5-2.94,5.72-5.76,1.37-5.08,1.37-15.68,1.37-15.68,0,0,.04-10.64-1.37-15.76-.73-2.78-2.94-5-5.72-5.72-5.12-1.41-25.55-1.41-25.55-1.41"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#137b5d",
    },
  },
};
</script>
